// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 768px) and (max-width: 1000px){.col-md-6{flex:1 0 50% !important;max-width:51% !important}}\n", ""]);
// Exports
module.exports = exports;
